import { Text } from "@offstreetparking/design-system/typography";
import type { AdditionalInfoFormData } from "../../../CreatePermitWizard/PermitContextProvider/types";

type ParkingAdditionalInfoProps = {
	fields: AdditionalInfoFormData["fields"];
};

export const ParkingAdditionalInfo = ({ fields }: ParkingAdditionalInfoProps) => {
	if (!fields?.length) {
		return null;
	}

	return (
		<div className="flex flex-col gap-2">
			{fields?.map((field) => {
				const labelId = `parking-additional-info-label-${field.permitFieldId}`;

				return (
					<div key={field.permitFieldId} className="flex flex-col">
						<Text As="span" id={labelId} size="sm" intent="muted" weight="medium">
							{field.label}
						</Text>
						<Text As="span" aria-labelledby={labelId}>
							{field.fileName ?? field.value}
						</Text>
					</div>
				);
			})}
		</div>
	);
};
